// Atualização periódica das telas de acompanhamento.
//
// As telas do Vision se atualizavam a cada 10 segundos, cada uma com vários
// intervalos em paralelo (o Monitor tinha 6). Isso gerava dezenas de requisições
// por minuto por aba aberta e era o multiplicador da carga no MongoDB: coleções
// de 5 a 108 documentos chegaram a dezenas de milhões de leituras em 9 dias.
//
// Duas mudanças resolvem isso sem alterar nenhuma consulta:
//   1. intervalo padrão de 60 segundos em vez de 10;
//   2. aba em segundo plano não consulta nada — e ao voltar, atualiza na hora,
//      para o usuário nunca olhar dado velho.

// Intervalo padrão das telas de acompanhamento. Mudar aqui vale para todas.
export const POLL_INTERVAL_MS = 60000;

/**
 * Passa a chamar `fn` a cada `intervalMs`, mas só enquanto a aba estiver
 * visível. Não faz a primeira chamada: quem usa já busca na montagem.
 *
 * Feito para ser devolvido direto no cleanup de um useEffect:
 *
 *   useEffect(() => {
 *     const fetchRequests = async () => { ... };
 *     fetchRequests();
 *     return startPolling(fetchRequests);
 *   }, [deps]);
 *
 * @param {Function} fn — o que executar em cada ciclo
 * @param {number} intervalMs — intervalo entre ciclos (default: 60s)
 * @returns {Function} cleanup — para o ciclo e remove o listener
 */
export function startPolling(fn, intervalMs = POLL_INTERVAL_MS) {
    let intervalId = null;
    let encerrado = false;

    const executar = () => {
        if (!encerrado && !document.hidden) fn();
    };

    const iniciar = () => {
        if (encerrado || intervalId !== null) return;
        intervalId = setInterval(executar, intervalMs);
    };

    const parar = () => {
        if (intervalId === null) return;
        clearInterval(intervalId);
        intervalId = null;
    };

    const aoTrocarVisibilidade = () => {
        if (document.hidden) {
            parar();
            return;
        }
        executar(); // voltou para a aba: atualiza sem esperar o próximo ciclo
        iniciar();
    };

    if (!document.hidden) iniciar();
    document.addEventListener('visibilitychange', aoTrocarVisibilidade);

    return () => {
        encerrado = true;
        parar();
        document.removeEventListener('visibilitychange', aoTrocarVisibilidade);
    };
}
